import React from 'react';

import { PDFDownloadLink } from '@react-pdf/renderer';
import downloadIcon from 'assets/img/icons/download.svg';
import { Spinner } from 'triider-components';
import { DownloadButton } from '../styles';

import { ProcessWrapper, Error } from './styles';

const ButtonPDF = ({
  msgError, validation, renderControl, file, fileName,
}) => {
  const [processPDF, setProcessPDF] = renderControl;

  return (
    <div>
      <Error>{msgError}</Error>
      {
        !processPDF

          ? (
            <DownloadButton
              type="button"
              style={{ width: '100%' }}
              iconLeft={downloadIcon}
              onClick={() => {
                if (validation()) { setProcessPDF(true); }
              }}
            >
              Gerar PDF

            </DownloadButton>
          )

          : (
            <PDFDownloadLink fileName={fileName} document={file} style={{ textDecoration: 'none' }}>
              {({ loading }) => (loading
                ? (
                  <ProcessWrapper>
                    <Spinner size="small" />
                    <p>Processando...</p>
                  </ProcessWrapper>
                )
                : (
                  <DownloadButton type="button" style={{ width: '100%' }} iconLeft={downloadIcon}>
                    Baixar resumo
                  </DownloadButton>
                ))}
            </PDFDownloadLink>
          )
      }
    </div>
  );
};

export default ButtonPDF;
